<template>
  <div v-if="showCaptcha" class="base-captcha">
    <div
      id="captcha-container"
      style="height: 100px"
      class="base-captcha__wrapper smart-captcha"
      :data-sitekey="captchaKey"
      data-callback="captchaCallback"
    />
  </div>
  <div v-else>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { permissions } from '../../lib'

interface Props {
  isAuthenticated: boolean
}

const props = defineProps<Props>()

const route = useRoute()
const { public: { captchaKey } } = useRuntimeConfig()

const captchaPassed = ref(false)
const isClient = ref(false)
const allowedNamesOfRoutes = [permissions.SHARED.SURVEYS.FILL.PERMISSION]
const routeName = computed(() => route.name as string)

const showCaptcha = computed(() =>
  !props.isAuthenticated
  && allowedNamesOfRoutes.includes(routeName.value)
  && captchaKey
  && !captchaPassed.value
  && isClient.value,
)

onMounted(() => {
  isClient.value = true

  if (showCaptcha.value) {
    ;(window as any).captchaCallback = () => {
      captchaPassed.value = true
    }
  }
})

useHead({
  script: computed(() => {
    if (!isClient.value || props.isAuthenticated || !showCaptcha.value) {
      return []
    }

    return [
      {
        src: 'https://smartcaptcha.yandexcloud.net/captcha.js',
        defer: true,
      },
    ]
  }),
})
</script>

<style lang="scss" scoped>
.base-captcha {
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;

  &__wrapper {
    height: 100px;
    width: 100%;
    max-width: 280px;
  }
}
</style>
